// run-detached-child-exit-codes.ts — 06k B11/N21: hằng mã thoát riêng của con
// `run --detached-child` (C1 ghi, C2 launcher đọc — một module dùng chung). Chỉ
// khi có `--detached-child`; foreground KHÔNG BAO GIỜ thoát 70–73 (I1: vẫn 1).
// Launcher chỉ map mã thoát ⇒ enum, không đọc log (luật 3 bí mật).
import { MachineLockBusyError, MachineLockRecoveringError } from "./mission-lock-errors.js";

export const DETACHED_CHILD_ERROR_CODES = {
  secrets_preflight: 70,
  release_stdin_refused: 71,
  machine_lock_busy: 72,
  machine_lock_recovering: 73,
} as const;

export type DetachedChildErrorKind = keyof typeof DETACHED_CHILD_ERROR_CODES;
export type ChildErrorCode = DetachedChildErrorKind | "other";

/** Mã thoát cho một lỗi đã phân loại: con tách rời ⇒ 70–73, foreground ⇒ 1 như cũ. */
export function runFailureExitCode(kind: DetachedChildErrorKind, detachedChild: boolean): number {
  return detachedChild ? DETACHED_CHILD_ERROR_CODES[kind] : 1;
}

/** Lỗi machine lock ⇒ loại tương ứng; lỗi khác ⇒ `undefined` (để nổi lên như cũ). */
export function machineLockErrorKind(err: unknown): DetachedChildErrorKind | undefined {
  if (err instanceof MachineLockBusyError) return "machine_lock_busy";
  if (err instanceof MachineLockRecoveringError) return "machine_lock_recovering";
  return undefined;
}

export function childErrorCodeForExit(exitCode: number): ChildErrorCode {
  const hit = Object.entries(DETACHED_CHILD_ERROR_CODES).find(([, code]) => code === exitCode);
  return hit === undefined ? "other" : (hit[0] as DetachedChildErrorKind);
}
